import { useEffect, useState } from "react";

const MDTimeTicker = ({ endDateTime }) => {
  const calculateTimeLeft = () => {
    if (!endDateTime) {
      return { days: 0, hours: 0, minutes: 0, seconds: 0 };
    }

    // Force "now" in America/Chicago
    const nowInChicago = new Date(
      new Intl.DateTimeFormat("en-US", {
        timeZone: "America/Chicago",
        hour12: false,
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit"
      }).format(new Date())
    );

    const endInChicago = new Date(endDateTime); // make sure this is in UTC/ISO format
  
    const difference = endInChicago.getTime() - nowInChicago.getTime();

    if (difference <= 0)
      return { days: 0, hours: 0, minutes: 0, seconds: 0 };

    return {
      days: Math.floor(difference / (1000 * 60 * 60 * 24)),
      hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
      minutes: Math.floor((difference / (1000 * 60)) % 60),
      seconds: Math.floor((difference / 1000) % 60),
    };
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(timer); // cleanup on unmount
  }, [endDateTime]);

  return (
    <div className="text-lg font-mono" style={{ whiteSpace: "nowrap" }}>
      {timeLeft.days}d {timeLeft.hours}h {timeLeft.minutes}m {timeLeft.seconds}s
    </div>
  );
};

export default MDTimeTicker;
